exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7890052c] .el-scrollbar__wrap{overflow-x:hidden}[data-v-7890052c] .el-table th.gutter{display:table-cell!important}", ""]);

// exports
